(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["roll-up-tee-measurements"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('roll-up-measurements'))customElements.define('roll-up-measurements',class extends HTMLElement{connectedCallback(){if(this.dataset.ready)return;const setup=()=>{const table=this.closest('section').querySelector('.ru-size');if(!table)return;this.dataset.ready='true';const rows=[...table.querySelectorAll('tbody tr')];rows.forEach((row,i)=>{if(!row.cells[0].textContent.trim().startsWith(String.fromCharCode(65+i)+' ·'))row.cells[0].prepend(String.fromCharCode(65+i)+' · ')});const select=index=>{this.querySelectorAll('[data-ru-size]').forEach(b=>b.setAttribute('aria-pressed',String(Number(b.dataset.ruSize)===index)));this.querySelectorAll('[data-ru-value]').forEach(label=>{let i=Number(label.dataset.ruValue);label.textContent=String.fromCharCode(65+i)+' · '+rows[i].cells[index+1].textContent.trim()});table.querySelectorAll('tr').forEach(row=>[...row.cells].forEach((c,i)=>c.classList.toggle('ru-selected',i===index+1)));this.querySelector('[data-ru-status]').textContent=table.tHead.rows[0].cells[index+1].textContent+': '+rows.map(row=>row.cells[0].textContent+' '+row.cells[index+1].textContent+' cm').join('; ')};this.querySelectorAll('[data-ru-size]').forEach(b=>b.addEventListener('click',()=>select(Number(b.dataset.ruSize))));select(1)};if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setup,{once:true});else setup()}});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rose-balance-measurements"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('rose-tee-measurements')){
customElements.define('rose-tee-measurements',class extends HTMLElement{
connectedCallback(){
if(this.dataset.ready)return;
const setup=()=>{
const table=this.closest('section').querySelector('.rb-size');
if(!table)return;
this.dataset.ready='true';
const rows=[...table.querySelectorAll('tbody tr')];
const select=(index)=>{
this.querySelectorAll('[data-rose-size]').forEach(button=>button.setAttribute('aria-pressed',String(Number(button.dataset.roseSize)===index)));
this.querySelectorAll('[data-rose-value]').forEach(label=>{const row=Number(label.dataset.roseValue);label.textContent=String.fromCharCode(65+row)+' · '+rows[row].cells[index+1].textContent.trim();});
table.querySelectorAll('tr').forEach(row=>[...row.cells].forEach((cell,i)=>cell.classList.toggle('rb-selected',i===index+1)));
this.querySelector('[data-rose-size-status]').textContent=table.tHead.rows[0].cells[index+1].textContent+': '+rows.map(row=>row.cells[0].textContent+' '+row.cells[index+1].textContent+' cm').join('; ');
};
this.querySelectorAll('[data-rose-size]').forEach(button=>button.addEventListener('click',()=>select(Number(button.dataset.roseSize))));select(1);
};
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setup,{once:true});else setup();
}
});}
  } catch(e) { console.error(e); }
})();

})();
